module.exports = __webpack_public_path__ + "static/media/lidingshan_mobile.e98ee562.png";